import React from 'react';

import { Button, Result } from 'antd';

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Unhandled render error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Result
                    status='500'
                    title='Something went wrong'
                    subTitle='An unexpected error occurred while rendering this page.'
                    extra={
                        <Button type='primary' onClick={() => window.location.reload()}>
                            Reload page
                        </Button>
                    }
                />
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
